import { useQuery, useMutation, useQueryClient } from 'react-query'
import { gateway } from '../utils/api'

export function usePopupFeedback (pollMs = 60000, trigger = 'popup_period', courseCode) {
  const qc = useQueryClient()
  const avail = useQuery(
    ['available-popup'],
    async () => {
      const res = await gateway.get('/feedback/form/available', {
        params: { trigger,  ...(courseCode ? { courseCode } : {}) }
      })
      if (res && res.hasAny !== undefined) {
        return res
      }
      if (res.status === 204) return { hasAny: false, forms: [] }
      return res.data
    },
    { refetchInterval: pollMs, refetchOnWindowFocus: false }
  )
  const checkStatus = (formCode) =>
    useQuery(['form-response-status', formCode], async () => {
      const res = await gateway.get('/feedback/response/status', {
        params: { formCode }
      });
      return res.data;
    }, {
      enabled: !!formCode,
      staleTime: 30000,
      cacheTime: 60000,
    });

  const start = useMutation(
    (formCode) =>
      gateway.post('/feedback/response/start', { surveyCode: formCode }),
    {
      onSuccess: () => {
        qc.invalidateQueries(['available-popup'])
      }
    }
  )
  const submit = useMutation(
    ({ formCode, answers }) =>
      gateway.post('/feedback/response/create', {
        formCode,
        answers
      }),
    { onSuccess: () => qc.invalidateQueries(['available-popup']) }
  )

  return { avail, start, submit, checkStatus }
}
